import { render } from "./RzList.vue?vue&type=template&id=0f6fa534"
import script from "./RzList.vue?vue&type=script&lang=js"
export * from "./RzList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__